import type { ViewerPluginCreator } from './../ricos-types';

import { DEFAULTS } from './defaults';
import type { LinkPreviewPluginViewerConfig } from './types';
import { LINK_PREVIEW_TYPE } from './types';
import { nodeViewRenderers } from './viewer/nodeViewRenderers';

export const pluginLinkPreview: ViewerPluginCreator<LinkPreviewPluginViewerConfig> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_PREVIEW_TYPE,
    nodeViewRenderers,
  };
};
